import { Schema } from 'js-data'
import * as PASchema from './PAdbSchema'
import * as _ from 'lodash'

import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default,
    KeyGenSpecs_Poolsize_200,
    KeyGenSpecs_Poolsize_250,
    KeyGenSpecs_Poolsize_50,
    KeyGenSpecs_Poolsize_500,
    KeyGenSpecs_Poolsize_2000,
    KeyGenSpecs_BigInt_default,
    KeyGenSpecs_BigInt_PoolSize_2000
} from './PAdbSchema'

// Jobs
export const WB_Job = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Jobs', // optional
    description: 'Schema for Jobs records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOB_ID: {
            type: 'number',
            id: true,
            required: true
        },
        JOB_ID: {
            type: 'string',
            length: 50
        },
        JOB_NAME: {
            type: 'string',
            length: 256
        },
        JOB_DESCRIPTION: {
            type: 'string',
            length: 1333
        },
        JOB_TYPE: {
            type: 'string',
            length: 50
        },
        ETL_NAME: {
            type: 'string',
            length: 50
        },
        JOB_TECHNICAL_NAME: {
            type: 'string',
            length: 50
        },
        JOB_OPTIONS: {
            type: 'string',
            length: 1333
        },
        DISPLAY_IND: {
            type: 'string',
            length: 1
        },
        TREE_PATH: {
            type: 'string',
            length: 256
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Job_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Job_Run]: { foreignKey: 'WB_JOB_ID', foreignKeyImmutable: true, localField: 'JobRuns' }
    }
}

// Job Run
export const WB_JobRun = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'JobRun', // optional
    description: 'Schema for JobRun records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOB_RUN_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_JOB_ID: {
            type: 'number'
        },
        SOURCE_ID: {
            type: 'string',
            length: 50
        },
        STARTDT: {
            type: 'string',
            length: 14
        },
        ENDDT: {
            type: 'string',
            length: 14
        },
        FINISH_DESCRIPTION: {
            type: 'string',
            length: 256
        },
        LOAD_COUNT: {
            type: 'number'
        },
        ERROR_TIME: {
            type: 'string',
            length: 14
        },
        ERROR_COUNT: {
            type: 'number'
        },
        ERROR_DESCRIPTION: {
            type: 'string',
            length: 256
        }
    }
})
export const WB_Job_Run_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job]: { foreignKey: 'WB_JOB_ID', foreignKeyImmutable: true, localField: 'Job' }
    }
}

//Job Schedule Process start
export const WB_Job_Schedule_Process_RelationShip = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Schedule', // optional
    description: 'Schema for Job Schedule records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOBSCHEDULEPROCESS_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_JOBSCHEDULE_ID: {
            type: 'number'
        },
        RUN_STAMP: {
            type: 'string',
            length: 50
        },
        PROCESS_STATUS: {
            type: 'string',
            length: 50
        },
        PROCESS_START_DTTS: {
            type: 'number'
        },
        PROCESS_END_DTTS: {
            type: 'number'
        },
        PROCESS_ERROR_DTTS: {
            type: 'number'
        },
        ERROR_IND: {
            type: 'string',
            length: 1
        },
        ERROR_MSG: {
            type: 'string',
            length: 1333
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Job_Schedule_Process_RelationShip_JSData_RELs = {
    belongsTo: {}
}

//End Job Schedule Process
export const WB_Job_Processor = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Processor', // optional
    description: 'Schema for Job Processor records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOBPROCESSOR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        JOBPROCESSOR_IDX: {
            type: 'number'
        },
        JOBPROCESSOR_HOSTNAME: {
            type: 'string',
            length: 100
        },
        JOBPROCESSOR_PID: {
            type: 'string',
            length: 50
        },
        JOB_TYPE: {
            type: 'string',
            length: 50
        },
        JOBPROCESSOR_STATUS: {
            type: 'string',
            length: 50
        },
        JOBPROCESSOR_HB_DTTS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Job_Processor_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Job_Process]: {
            foreignKey: 'WB_JOBPROCESSOR_ID',
            foreignKeyImmutable: true,
            localField: 'JobProcesses'
        }
    }
}

export const WB_Job_Processor_ConfigR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Processor Config Relationship records', // optional
    description: 'Schema for Job Processor Config R records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOBPROCESSOR_CONFIGR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MACHINE_TYPE_ID: {
            type: 'string',
            length: 100
        },
        JOB_PROCESSOR_TYPE: {
            type: 'string',
            length: 100
        },
        WORKER_COUNT: {
            type: 'number'
        },
        POLLING_INTERVAL_SECONDS: {
            type: 'number'
        },
        QUEUE_ALLOWABLE_FAILURE_COUNT: {
            type: 'number'
        },
        QUEUE_TIMEOUT_THRESHOLD_SECONDS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Job_Processor_ConfigR_JSData_RELs = {}

export const WB_Job_Process = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Process', // optional
    description: 'Schema for Job Process records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOBPROCESS_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_JOB_PARAMSR_ID: {
            type: 'number'
        },
        WB_JOB_PARAM_ID: {
            type: 'number'
        },
        WB_UI_APPEXEC_ID_OUTPUT: {
            type: 'number'
        },
        WB_ID_OUTPUT: {
            type: 'number'
        },
        RUN_ID: {
            type: 'string',
            length: 50
        },
        QUEUE_IND: {
            type: 'string',
            length: 1
        },
        PROCESS_STATUS: {
            type: 'string',
            length: 50
        },
        QUEUE_CREATE_STATUS: {
            type: 'string',
            length: 50
        },
        PROCESS_START_DTTS: {
            type: 'number'
        },
        PROCESS_END_DTTS: {
            type: 'number'
        },
        PROCESS_CLAIMED_DTTS: {
            type: 'number'
        },
        PROCESS_TIMEOUT_DTTS: {
            type: 'number'
        },
        PROCESS_ERROR_DTTS: {
            type: 'number'
        },
        PROCESS_PROGRESS_PCNT: {
            type: 'number'
        },
        PROCESS_PROGRESS_D: {
            type: 'number'
        },
        ERROR_IND: {
            type: 'string',
            length: 1
        },
        ERROR_MSG: {
            type: 'string',
            length: 1333
        },
        WB_JOBPROCESSOR_ID: {
            type: 'number'
        },
        JOBPROCESSOR_HB_DTTS: {
            type: 'number'
        },
        WB_JOB_TRIGGER_ID: {
            type: 'number'
        },
        WB_QUEUE_CREATED_DTTS: {
            type: 'number'
        },
        ALLOWABLE_FAILURE_COUNT: {
            type: 'number'
        },
        TIMEOUT_THRESHOLD_SECONDS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Job_Process_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Processor]: {
            foreignKey: 'WB_JOBPROCESSOR_ID',
            foreignKeyImmutable: true,
            localField: 'JobProcessor'
        },
        [PASchema.esWB_Job_Param]: {
            foreignKey: 'WB_JOB_PARAM_ID',
            foreignKeyImmutable: true,
            localField: 'JobParam'
        }
    }
}

export const WB_Job_Process_Queue = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Process Queue', // optional
    description: 'Schema for Job Process Queue records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOB_PROCESS_QUEUE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        QUEUE_ID: {
            type: 'string',
            length: 50
        },
        ITEM_TYPE: {
            type: 'string',
            length: 50
        },
        WB_JOB_PROCESS_QUEUE_ID_PARENT: {
            type: 'number'
        },
        WB_UI_APPEXEC_ID_ITEM: {
            type: 'number'
        },
        ITEM_WB_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        PROCESS_STATUS: {
            type: 'string',
            length: 50
        },
        FAILURE_COUNT: {
            type: 'number'
        },
        WB_JOBPROCESS_ID: {
            type: 'number'
        },
        JOB_PROCESSOR_TYPE: {
            type: 'string',
            length: 50
        },
        WB_JOBPROCESSOR_ID: {
            type: 'number'
        },
        RUN_ID: {
            type: 'number'
        },
        PROCESS_CLAIMED_DTTS: {
            type: 'number'
        },
        PROCESS_TIMEOUT_DTTS: {
            type: 'number'
        },
        PROCESS_START_DTTS: {
            type: 'number'
        },
        PROCESS_END_DTTS: {
            type: 'number'
        },
        MESSAGE: {
            type: 'string',
            length: 1333
        },
        ALLOWABLE_FAILURE_COUNT: {
            type: 'number'
        },
        TIMEOUT_THRESHOLD_SECONDS: {
            type: 'number'
        }
    }
})

export const WB_Job_Process_Queue_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Processor]: {
            foreignKey: 'WB_JOBPROCESSOR_ID',
            foreignKeyImmutable: true,
            localField: 'JobProcessor'
        }
    }
}

// Job Params
export const WB_Job_Param = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Parameters', // optional
    description: 'Schema for Job Parameter records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOB_PARAM_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_COMPANY_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        JOB_PARAM_ID: {
            type: 'string',
            length: 250
        },
        JOB_PARAM_NAME: {
            type: 'string',
            length: 250
        },
        WB_ID_TARGET: {
            type: 'number'
        },
        JOB_MODULE_ID: {
            type: 'string',
            length: 50
        },
        JOB_PROCESSOR_TYPE: {
            type: 'string',
            length: 50
        },
        DEPENDENT_TRIGGER_ID: {
            type: 'string',
            length: 50
        },
        JOB_OPTIONS: {
            type: 'string',
            length: 1333
        },
        CREATE_ITEM_QUEUE_IND: {
            type: 'string',
            length: 1
        },
        DISABLED_IND: {
            type: 'string',
            length: 1
        },
        WB_UI_APPEXEC_ID_TARGET: {
            type: 'number'
        },
        SOURCE_TYPE: {
            type: 'string',
            length: 50
        },
        SOURCE_WB_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Job_Param_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamMdSet'
        },
        [PASchema.esWB_Company]: {
            foreignKey: 'WB_COMPANY_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamCompany'
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: 'WB_SALESORG_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamSalesOrg'
        },
        [PASchema.esWB_UI_AppExecutable]: {
            foreignKey: 'WB_UI_APPEXEC_ID_TARGET',
            foreignKeyImmutable: true,
            localField: 'JobParamExec'
        }
    },
    hasMany: {
        [PASchema.esWB_Job_ParamSR]: {
            foreignKey: 'WB_JOB_PARAM_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamScheduleXref'
        }
    }
}

export const WB_Job_ParamSR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Parameter Schedule Xref', // optional
    description: 'Schema for Job Parameter Schedule Xref records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOB_PARAMSR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_JOB_PARAM_ID: {
            type: 'number'
        },
        WB_SCHEDULE_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Job_ParamSR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Param]: {
            foreignKey: 'WB_JOB_PARAM_ID',
            foreignKeyImmutable: true,
            localField: 'JobParam'
        },
        [PASchema.esWB_Schedule]: {
            foreignKey: 'WB_SCHEDULE_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamSchedule'
        }
    }
}

// Job Trigger
export const WB_Job_Trigger = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Job Triggers', // optional
    description: 'Schema for Job Trigger records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_JOB_TRIGGER_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_COMPANY_ID: {
            type: 'number'
        },
        WB_JOB_PROCESS_ID_CREATED_BY: {
            type: 'number'
        },
        TRIGGERED_JOB_PARAM_DETAIL: {
            type: 'string',
            length: 1333
        },
        TRIGGER_ID: {
            type: 'string',
            length: 50
        },
        TRIGGER_DTTS: {
            type: 'number'
        },
        PROCESSED_IND: {
            type: 'string',
            length: 1
        }
    }
})

export const WB_Job_Trigger_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamMdSet'
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: 'WB_SALESORG_ID',
            foreignKeyImmutable: true,
            localField: 'JobParamSalesOrg'
        },
        [PASchema.esWB_Company]: {
            foreignKey: 'WB_COMPANY_ID',
            foreignKeyImmutable: true,
            localField: 'JobTriggerCompany'
        }
    }
}

// Automation
export const WB_Automation_Domain = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation Domain', // optional
    description: 'Schema for Automation Domain records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_DOMAIN_ID: {
            type: 'number',
            id: true,
            required: true
        },
        AUTOMATION_DOMAIN_ID: {
            type: 'string',
            length: 50
        },
        VERSION: {
            type: 'string',
            length: 50
        },
        AUTOMATION_DOMAIN: {
            type: 'string',
            length: 2147483647
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_Domain_JSData_RELs = {}

export const WB_Automation_Flow = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation Flow', // optional
    description: 'Schema for Automation Flow records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_FLOW_ID: {
            type: 'number',
            id: true,
            required: true
        },
        AUTOMATION_FLOW_ID: {
            type: 'string',
            length: 50
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        AUTOMATION_FLOW: {
            type: 'string',
            length: 2147483647
        },
        TEMPLATE_IND: {
            type: 'string',
            length: 1
        },
        MODULE_ID: {
            type: 'string',
            length: 50
        },
        EMBEDDED_IND: {
            type: 'string',
            length: 1
        },
        SOURCE_TYPE: {
            type: 'string',
            length: 50
        },
        SOURCE_WB_ID: {
            type: 'number'
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_Flow_JSData_RELs = {}

export const WB_Automation_Flow_ADR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation Flow ADR', // optional
    description: 'Schema for Automation Flow ADR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_FLOWADR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_AUTOMATION_FLOW_ID: {
            type: 'number'
        },
        WB_AUTOMATION_DOMAIN_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_Flow_ADR_JSData_RELs = {}

export const WB_Automation_Flow_Graph = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation Flow Graph', // optional
    description: 'Schema for Automation Flow Graph records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_FLOWGRAPH_ID: {
            type: 'number',
            id: true,
            required: true
        },
        AUTOMATION_FLOWGRAPH_ID: {
            type: 'string',
            length: 50
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        TEMPLATE_IND: {
            type: 'string',
            length: 1
        },
        MODULE_ID: {
            type: 'string',
            length: 50
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_Flow_Graph_JSData_RELs = {}

export const WB_Automation_State_Machine = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation State Machine', // optional
    description: 'Schema for Automation State Machine records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_STATEMACHINE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        AUTOMATION_STATEMACHINE_ID: {
            type: 'string',
            length: 50
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        TEMPLATE_IND: {
            type: 'string',
            length: 1
        },
        MODULE_ID: {
            type: 'string',
            length: 50
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_State_Machine_JSData_RELs = {}

// Automation Runtime Logging
export const WB_Automation_Run_History = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation Run History', // optional
    description: 'Schema for Automation Run History records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_RUN_HISTORY_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_AUTOMATION_FLOW_ID: {
            type: 'number'
        },
        WB_AUTOMATION_STATEMACHINE_ID: {
            type: 'number'
        },
        WB_AUTOMATION_FLOWGRAPH_ID: {
            type: 'number'
        },
        PARAMS: {
            type: 'string',
            length: 5000
        },
        START_DTTS: {
            type: 'number'
        },
        END_DTTS: {
            type: 'number'
        },
        MESSAGE: {
            type: 'string',
            length: 2000
        },
        ERROR_IND: {
            type: 'string',
            length: 1
        },
        ERROR_MSG: {
            type: 'string',
            length: 2000
        },
        WB_REFERENCE_TYPE: {
            type: 'string',
            length: 50
        },
        WB_REFERENCE_ID: {
            type: 'number'
        },
        WB_JOBPROCESS_ID: {
            type: 'number'
        },
        WB_JOB_PROCESS_QUEUE_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_Run_History_JSData_RELs = {}

export const WB_Automation_Run_History_SR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Automation Run History SR', // optional
    description: 'Schema for Automation Run History SR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AUTOMATION_RUN_HISTORYSR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_AUTOMATION_RUN_HISTORY_ID: {
            type: 'number'
        },
        STEP_ID: {
            type: 'number'
        },
        OPERATION_ID: {
            type: 'number'
        },
        OPERATION_ID_UI: {
            type: 'string',
            length: 50
        },
        MESSAGE: {
            type: 'string',
            length: 2000
        },
        ERROR_IND: {
            type: 'string',
            length: 1
        },
        ERROR_MSG: {
            type: 'string',
            length: 2000
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Automation_Run_History_SR_JSData_RELs = {}

// Batch Process
export const WB_BatchProcess = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Batch Process', // optional
    description: 'Schema for Batch Process records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_BATCHPROCESS_ID: {
            type: 'number',
            id: true,
            required: true
        },
        BATCHPROCESS_ID: {
            type: 'string',
            length: 50
        },
        BATCHPROCESS_NAME: {
            type: 'string',
            length: 50
        },
        JOB_ID: {
            type: 'string',
            length: 50
        },
        WB_BATCHSCOPE_ID: {
            type: 'number',
            required: true
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_BatchProcess_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScope'
        }
    }
}

export const WB_BatchScope = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Batch Scope', // optional
    description: 'Schema for Batch Scope records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_BATCHSCOPE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        BATCHSCOPE_ID: {
            type: 'string',
            length: 50
        },
        BATCHSCOPE_NAME: {
            type: 'string',
            length: 50
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        }
    }
})

export const WB_BatchScope_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_BatchProcess]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchProcesses'
        },
        [PASchema.esWB_BatchScopeCR]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScopeCRs'
        },
        [PASchema.esWB_BatchScopeMR]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScopeMRs'
        },
        [PASchema.esWB_BatchScopeSR]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScopeSRs'
        }
    }
}

export const WB_BatchScopeCR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Batch Scope MDSet', // optional
    description: 'Schema for Batch Scope MDSet records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_BATCHSCOPECR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_BATCHSCOPE_ID: {
            type: 'number',
            required: true
        },
        WB_COMPANY_ID: {
            type: 'number',
            required: true
        },
        EXCLUDE_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_BatchScopeCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScope'
        },
        [PASchema.esWB_Company]: {
            foreignKey: 'WB_COMPANY_ID',
            foreignKeyImmutable: true,
            localField: 'Company'
        }
    }
}

export const WB_BatchScopeMR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Batch Scope MDSet', // optional
    description: 'Schema for Batch Scope MDSet records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_BATCHSCOPEMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_BATCHSCOPE_ID: {
            type: 'number',
            required: true
        },
        WB_MDSET_ID: {
            type: 'number',
            required: true
        },
        EXCLUDE_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_BatchScopeMR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScope'
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MDSet'
        }
    }
}

export const WB_BatchScopeSR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Batch Scope MDSet', // optional
    description: 'Schema for Batch Scope MDSet records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_BATCHSCOPESR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_BATCHSCOPE_ID: {
            type: 'number',
            required: true
        },
        WB_SALESORG_ID: {
            type: 'number',
            required: true
        },
        EXCLUDE_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_BatchScopeSR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_BatchScope]: {
            foreignKey: 'WB_BATCHSCOPE_ID',
            foreignKeyImmutable: true,
            localField: 'BatchScope'
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: 'WB_SALESORG_ID',
            foreignKeyImmutable: true,
            localField: 'SalesOrg'
        }
    }
}

// Queues
export const WB_Queue = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Jobs', // optional
    description: 'Schema for Jobs records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_QUEUE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        QUEUE_ID: {
            type: 'string',
            length: 50
        },
        ITEM_TYPE: {
            type: 'string',
            length: 50
        },
        WB_QUEUE_ID_PARENT: {
            type: 'number'
        },
        WB_UI_APPEXEC_ID_ITEM: {
            type: 'number'
        },
        ITEM_WB_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        PROCESS_STATUS: {
            type: 'string',
            length: 50
        },
        FAILURE_COUNT: {
            type: 'number'
        },
        WB_JOBPROCESS_ID: {
            type: 'number'
        },
        JOB_PROCESSOR_TYPE: {
            type: 'string',
            length: 50
        },
        WB_JOBPROCESSOR_ID: {
            type: 'number'
        },
        RUN_ID: {
            type: 'number'
        },
        PROCESS_CLAIMED_DTTS: {
            type: 'number'
        },
        PROCESS_TIMEOUT_DTTS: {
            type: 'number'
        },
        PROCESS_START_DTTS: {
            type: 'number'
        },
        PROCESS_END_DTTS: {
            type: 'number'
        },
        MESSAGE: {
            type: 'string',
            length: 1333
        },
        ALLOWABLE_FAILURE_COUNT: {
            type: 'number'
        },
        TIMEOUT_THRESHOLD_SECONDS: {
            type: 'number'
        }
    }
})
export const WB_Queue_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Job_Processor]: {
            foreignKey: 'WB_JOBPROCESSOR_ID',
            foreignKeyImmutable: true,
            localField: 'JobProcessor'
        }
    }
}

// Schedule
export const WB_Schedule = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Schedule', // optional
    description: 'Schema for Schedule records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCHEDULE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number',
            required: true
        },
        WB_SALESORG_ID: {
            type: 'number',
            required: true
        },
        SCHEDULE_NAME: {
            type: 'string',
            length: 50
        },
        SCHEDULE_TYPE: {
            type: 'string',
            length: 20
        },
        SCHEDULE_START_DTTS: {
            type: 'number'
        },
        SCHEDULE_END_DTTS: {
            type: 'number'
        },
        LAST_RUN_STAMP: {
            type: 'string',
            length: 50
        },
        RULE_TIMEZONE: {
            type: 'string',
            length: 20
        },
        RULE_FREQUENCY: {
            type: 'string',
            length: 20
        },
        RULE_COUNT: {
            type: 'number'
        },
        RULE_INTERVAL: {
            type: 'number'
        },
        RULE_WEEK_START_DAY: {
            type: 'string',
            length: 20
        },
        RULE_WEEK_DAYS: {
            type: 'string',
            length: 100
        },
        RULE_MONTHS: {
            type: 'string',
            length: 100
        },
        RULE_MONTH_LAST_DAY_IND: {
            type: 'string',
            length: 1
        },
        RULE_SET_POSITIONS: {
            type: 'string',
            length: 100
        },
        RULE_MONTH_DAYS: {
            type: 'string',
            length: 100
        },
        RULE_YEAR_DAYS: {
            type: 'string',
            length: 100
        },
        RULE_WEEK_NUMBERS: {
            type: 'string',
            length: 100
        },
        RULE_BY_HOURS: {
            type: 'string',
            length: 100
        },
        RULE_BY_MINUTES: {
            type: 'string',
            length: 100
        },
        RULE_BY_SECONDS: {
            type: 'string',
            length: 100
        },
        PROCESSED_START_DTTS: {
            type: 'number'
        },
        PROCESSED_END_DTTS: {
            type: 'number'
        },
        PROCESS_STATUS: {
            type: 'string',
            length: 50
        },
        OBJECT_TYPE_ID: {
            type: 'string',
            length: 50
        },
        OBJECT_WB_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        WB_AUTHUSR_ID_MODIFIED: {
            type: 'number'
        }
    }
})
export const WB_Schedule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_MODIFIED',
            foreignKeyImmutable: true,
            localField: 'User'
        }
    }
}

// Reference by mapper

_.defaults(dctSchemaByEntitySet, {
    [PASchema.esWB_Job]: WB_Job,
    [PASchema.esWB_Job_Process]: WB_Job_Process,
    [PASchema.esWB_Job_Process_Queue]: WB_Job_Process_Queue,
    [PASchema.esWB_Job_Processor]: WB_Job_Processor,
    [PASchema.esWB_Job_Processor_ConfigR]: WB_Job_Processor_ConfigR,
    [PASchema.esWB_Job_Run]: WB_JobRun,
    [PASchema.esWB_Job_Trigger]: WB_Job_Trigger,
    [PASchema.esWB_Job_Schedule_Process]: WB_Job_Schedule_Process_RelationShip,
    [PASchema.esWB_Job_Param]: WB_Job_Param,
    [PASchema.esWB_Job_ParamSR]: WB_Job_ParamSR,

    [PASchema.esWB_Automation_Domain]: WB_Automation_Domain,
    [PASchema.esWB_Automation_Flow]: WB_Automation_Flow,
    [PASchema.esWB_Automation_FlowADR]: WB_Automation_Flow_ADR,
    [PASchema.esWB_Automation_FlowGraph]: WB_Automation_Flow_Graph,
    [PASchema.esWB_Automation_StateMachine]: WB_Automation_State_Machine,
    [PASchema.esWB_Automation_Run_History]: WB_Automation_Run_History,
    [PASchema.esWB_Automation_Run_HistorySR]: WB_Automation_Run_History_SR,

    [PASchema.esWB_BatchProcess]: WB_BatchProcess,
    [PASchema.esWB_BatchScope]: WB_BatchScope,
    [PASchema.esWB_BatchScopeCR]: WB_BatchScopeCR,
    [PASchema.esWB_BatchScopeMR]: WB_BatchScopeMR,
    [PASchema.esWB_BatchScopeSR]: WB_BatchScopeSR,

    [PASchema.esWB_Queue]: WB_Queue,

    [PASchema.esWB_Schedule]: WB_Schedule
})

// These tables need to be moved into the JSData Schemas
_.defaults(dctTableNameByEntitySet, {
    [PASchema.esWB_Job]: '/AZR/WB_JOB',
    [PASchema.esWB_Job_Process]: '/AZR/WB_JOB_PROCESS',
    [PASchema.esWB_Job_Process_Queue]: '/AZR/WB_JOB_PROCESS_QUEUE',
    [PASchema.esWB_Job_Processor]: '/AZR/WB_JOB_PROCESSOR',
    [PASchema.esWB_Job_Processor_ConfigR]: '/AZR/WB_JOB_PROCESSOR_CONFIGR',
    [PASchema.esWB_Job_Run]: '/AZR/WB_JOBRUN',
    [PASchema.esWB_Job_Trigger]: '/AZR/WB_JOB_TRIGGER',
    [PASchema.esWB_Job_Schedule_Process]: '/AZR/WB_JOB_SCHEDULE_PROCESS',
    [PASchema.esWB_Job_Param]: '/AZR/WB_JOB_PARAM',
    [PASchema.esWB_Job_ParamSR]: '/AZR/WB_JOB_PARAMSR',

    [PASchema.esWB_Automation_Domain]: '/AZR/WB_AUTOMATION_DOMAIN',
    [PASchema.esWB_Automation_Flow]: '/AZR/WB_AUTOMATION_FLOW',
    [PASchema.esWB_Automation_FlowADR]: '/AZR/WB_AUTOMATION_FLOWADR',
    [PASchema.esWB_Automation_FlowGraph]: '/AZR/WB_AUTOMATION_FLOWGRAPH',
    [PASchema.esWB_Automation_StateMachine]: '/AZR/WB_AUTOMATION_STATEMACHINE',
    [PASchema.esWB_Automation_Run_History]: '/AZR/WB_AUTOMATION_RUN_HISTORY',
    [PASchema.esWB_Automation_Run_HistorySR]: '/AZR/WB_AUTOMATION_RUN_HISTORYSR',

    [PASchema.esWB_BatchProcess]: '/AZR/WB_BATCHPROCESS',
    [PASchema.esWB_BatchScope]: '/AZR/WB_BATCHSCOPE',
    [PASchema.esWB_BatchScopeCR]: '/AZR/WB_BATCHSCOPECR',
    [PASchema.esWB_BatchScopeMR]: '/AZR/WB_BATCHSCOPEMR',
    [PASchema.esWB_BatchScopeSR]: '/AZR/WB_BATCHSCOPESR',

    [PASchema.esWB_Queue]: '/AZR/WB_QUEUE',
    [PASchema.esWB_Queue_RunId]: '/AZR/WB_QUEUE',

    [PASchema.esWB_Schedule]: '/AZR/WB_SCHEDULE'
})

// TODO: Complete logical keys for metadata export
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_Job]: ['JOB_ID'],
    [PASchema.esWB_Job_Run]: ['WB_JOB_ID', 'SOURCE_ID'],
    [PASchema.esWB_Job_Trigger]: [],
    [PASchema.esWB_Job_Processor_ConfigR]: ['MACHINE_TYPE_ID', 'JOB_PROCESSOR_TYPE'],

    [PASchema.esWB_Job_Param]: ['SOURCE_TYPE', 'SOURCE_WB_ID'],
    [PASchema.esWB_Automation_Domain]: ['AUTOMATION_DOMAIN_ID', 'VERSION']
})

//maps tables to foreign keys that aren't part of JSDataRels for dataexporter/importer
//TODO: Fill out foreign key references that aren't part of the natural key
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_Job]: {},
    [PASchema.esWB_Job_Run]: { ['WB_JOB_ID']: PASchema.esWB_Job },
    [PASchema.esWB_Job_Param]: {
        ['WB_MDSET_ID']: PASchema.esWB_MasterData_Set,
        ['WB_SALESORG_ID']: PASchema.esWB_SalesOrg
    },
    [PASchema.esWB_Job_ParamSR]: {
        ['WB_JOB_PARAM_ID']: PASchema.esWB_Job_Param,
        ['WB_SCHEDULE_ID']: PASchema.esWB_Schedule,
        ['WB_AUTHUSR_ID_CREATEDBY']: PASchema.esWB_Schedule
    },
    [PASchema.esWB_BatchScope]: {},
    [PASchema.esWB_BatchScopeCR]: {},
    [PASchema.esWB_BatchScopeMR]: {},
    [PASchema.esWB_BatchScopeSR]: {}
})

_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_Job]: { sequence_name: '/AZR/WB_JOB_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Run]: { sequence_name: '/AZR/WB_JOB_RUN_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Trigger]: { sequence_name: '/AZR/WB_JOB_TRIGGER_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Process]: { sequence_name: '/AZR/WB_JOB_PROCESS_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Process_Queue]: { sequence_name: '/AZR/WB_JOB_PROCESS_QUEUE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Processor]: { sequence_name: '/AZR/WB_JOB_PROCESSOR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Processor_ConfigR]: {
        sequence_name: '/AZR/WB_JOB_PROCESSOR_CONFIGR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Job_Schedule_Process]: { sequence_name: '/AZR/WB_JOB_SCHEDULE_PROCESS_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Queue]: { sequence_name: '/AZR/WB_QUEUE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Queue_RunId]: { sequence_name: '/AZR/WB_QUEUE_RUN_ID_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Schedule]: { sequence_name: '/AZR/WB_SCHEDULE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_Param]: { sequence_name: '/AZR/WB_JOB_PARAM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Job_ParamSR]: { sequence_name: '/AZR/WB_JOB_PARAMSR_SEQ', ...KeyGenSpecs_default },

    [PASchema.esWB_Automation_Domain]: { sequence_name: '/AZR/WB_AUTOMATION_DOMAIN_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Automation_Flow]: { sequence_name: '/AZR/WB_AUTOMATION_FLOW_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Automation_FlowADR]: { sequence_name: '/AZR/WB_AUTOMATION_FLOWADR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Automation_FlowGraph]: { sequence_name: '/AZR/WB_AUTOMATION_FLOWGRAPH_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Automation_StateMachine]: {
        sequence_name: '/AZR/WB_AUTOMATION_STATEMACHINE_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Automation_Run_History]: {
        sequence_name: '/AZR/WB_AUTOMATION_RUN_HISTORY_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Automation_Run_HistorySR]: {
        sequence_name: '/AZR/WB_AUTOMATION_RUN_HISTORYSR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_BatchProcess]: { sequence_name: '/AZR/WB_BATCHPROCESS_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScope]: { sequence_name: '/AZR/WB_BATCHSCOPE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScopeCR]: { sequence_name: '/AZR/WB_BATCHSCOPECR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScopeMR]: { sequence_name: '/AZR/WB_BATCHSCOPEMR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_BatchScopeSR]: { sequence_name: '/AZR/WB_BATCHSCOPESR_SEQ', ...KeyGenSpecs_default }
})
